import type { RootState } from './RootReducer';
import type { WalletDetailsOption } from './WalletDetailsSlice';
import type { Middleware } from '@reduxjs/toolkit';

import {
  resetFilters,
  setHideEmptyWallets,
  setHideSmallBalances,
  setHideUnsupportedTokens,
  WALLET_DETAILS_LOCAL_STORAGE_KEY,
} from './WalletDetailsSlice';

export {
  AUTH_PERSIST_KEY,
  loadPersistedState,
  persistProfileState,
  PROFILE_PERSIST_KEY,
} from '@rango-dev/internal-profile/store';

const isWalletDetailsPersistActions = (action: any) => {
  if (
    action.type === setHideSmallBalances.type ||
    action.type === setHideEmptyWallets.type ||
    action.type === setHideUnsupportedTokens.type ||
    action.type === resetFilters.type
  ) {
    return true;
  }

  return false;
};

// Middleware to persist only WalletDetailsOption to localStorage
export const walletDetailsMiddleware: Middleware<object, RootState> =
  (storeAPI) => (next) => (action) => {
    const result = next(action);
    if (isWalletDetailsPersistActions(action)) {
      const state = storeAPI.getState().walletDetails;
      const walletDetailsOptions: WalletDetailsOption = {
        hideSmallBalances: state.hideSmallBalances,
        hideEmptyWallets: state.hideEmptyWallets,
        hideUnsupportedTokens: state.hideUnsupportedTokens,
      };
      localStorage.setItem(WALLET_DETAILS_LOCAL_STORAGE_KEY, JSON.stringify(walletDetailsOptions));
    }

    return result;
  };
